import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { SetupWizard } from "@/modules/proposal-builder/components/setup/SetupWizard";
import { useBrandSettings } from "@/modules/proposal-builder/hooks/useBrandSettings";

export const Route = createFileRoute("/proposal-builder/setup")({
  component: ProposalBuilderSetupRoute,
});

function ProposalBuilderSetupRoute() {
  const { isLoading, isError } = useBrandSettings();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0f0f0f] text-white">
        <Loader2 className="h-5 w-5 animate-spin text-white/40" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0f0f0f] px-6 text-center text-white">
        <div>
          <h1 className="text-xl font-semibold">Unable to load setup</h1>
          <p className="mt-2 text-sm text-white/45">
            Refresh the page and try again. If this keeps happening, check your
            brand settings connection.
          </p>
        </div>
      </div>
    );
  }

  return <SetupWizard />;
}